import Vue from "vue";
import App from "@/App.vue";
import router from "@/router";
import store from "@/store/";
// import BootstrapVue from "bootstrap-vue";
import { library } from "@fortawesome/fontawesome-svg-core";

import {
  faUser,
  faBell,
  faEnvelope,
  faKey,
  faTimes,
  faCogs,
  faCog,
  faClipboardList,
  faBars,
  faAsterisk,
  faSave,
  faSpinner,
  faIdCardAlt,
  faFolderOpen,
  faTrash,
  faCheck
} from "@fortawesome/free-solid-svg-icons";
import { faCheckSquare, faSquare } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(
  faUser,
  faBell,
  faEnvelope,
  faKey,
  faTimes,
  faCogs,
  faCog,
  faClipboardList,
  faBars,
  faAsterisk,
  faSave,
  faSpinner,
  faIdCardAlt,
  faFolderOpen,
  faTrash,
  faCheck,
  faCheckSquare,
  faSquare
);
Vue.config.productionTip = false;

// Vue.use(BootstrapVue);
Vue.component("fa", FontAwesomeIcon);

import axios from "axios";
import { loadProgressBar } from "axios-progress-bar";

loadProgressBar({ showSpinner: false });

import Element from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import locale from "element-ui/lib/locale/lang/en";
Vue.use(Element, { locale });

store.dispatch("auth/init");

import "@/assets/app.scss";
import "axios-progress-bar/dist/nprogress.css";

// var _ = require("lodash");
// import AsyncValidator from "async-validator";
// import messages from "@/models/ValidatorMessages";
// _.merge(AsyncValidator.messages, messages);

// import moment from "moment";
import moment from "moment-timezone";
import Vue2Filters from "vue2-filters";
Vue.use(Vue2Filters);

// custom filter
// date filter
Vue.filter("dateFormat", function(value, format) {
  if (!value) return "";
  var date = moment(value);
  if (format) {
    return date.format(format);
  }
  return date.format("MM/DD/YYYY");
});

Vue.filter("dateForHumans", function(value) {
  if (!value) return "";
  let date = moment(value).tz("Asia/Dubai");
  let now = moment().tz("Asia/Dubai");
  console.log(date, now);
  let diff = date.diff(now, "days");
  if (diff >= 0 && diff <= 7) {
    return date.from(now);
  } else {
    return date.format("MMM D, YYYY");
  }
});

// custom components
// import AppUploader from "@/components/AppUploader.vue";
Vue.component("AppUploader", require("./components/AppUploader.vue").default);
Vue.component("AppDialog", require("./components/AppDialog.vue").default);
Vue.component("AppDrawer", require("./components/AppDrawer.vue").default);

import Highcharts from "highcharts";
import Highcharts3d from "highcharts/highcharts-3d";
import HighchartsVue from "highcharts-vue";
Highcharts3d(Highcharts);
Vue.use(HighchartsVue);

import VueMasonry from "vue-masonry-css";
Vue.use(VueMasonry);

let app = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

// Add a response interceptor
axios.interceptors.response.use(
  response => {
    if (
      response.data &&
      response.data.data &&
      response.data.data.code &&
      response.data.data.code != 200
    ) {
      app.$notify({
        type: "warning",
        message: `${response.data.data.code}: ${response.data.data.message}`,
        position: "bottom-right"
      });
    }
    return response;
  },
  function(...error) {
    if (
      typeof error[0].isAxiosError !== "undefined" &&
      error[0].isAxiosError === true &&
      typeof error[0].response == "undefined"
    ) {
      app.$notify({
        type: "error",
        message: `AXIOS_ERROR: ${error[0].message}`,
        position: "bottom-right"
      });
    } else if (error[0].response.status == 400) {
      return Promise.resolve();
    } else if (error[0].response.status == 401) {
      store.dispatch("auth/logout").then(() => {
        store.commit("auth/clearUser");
        router.push("/login");
      });
      return Promise.resolve();
    } else {
      app.$notify({
        type: "error",
        message: `AXIOS_ERROR: ${error[0].response.statusText}`,
        position: "bottom-right"
      });
    }

    return Promise.reject(error);
  }
);
